/* eslint-disable consistent-return */

const parsePagePath = (path) => {
  if (path === '/') {
    return [path];
  }
  const pathList = path.split('/');
  const parsePathList = [];

  pathList.forEach((element) => {
    if (element) {
      parsePathList.push(`/${element}`);
    }
  });

  return parsePathList;
};

function isValidHash(hash) {
  if (!hash) {
    return false;
  }

  const decodedHash = decodeURIComponent(hash);
  return /^#.*$/.test(decodedHash);
}
// 主要以id为格式的跳转，需要通过id去寻找真实路径
const resolvePath = (pageID2PathMap, target, routerQuery, hash) => {
  let path;
  if (typeof target === 'string') {
    if (/(#|\?)/g.test(target)) {
      // 为了兼容老版，若路径带query则就是真实地址
      path = target;
    } else if (!pageID2PathMap[target] || !pageID2PathMap[target].fullPath) {
      path = target;
    } else {
      path = pageID2PathMap[target].fullPath;
      if (routerQuery && Object.keys(routerQuery).length) {
        const queryArr = [];
        for (const key in routerQuery) {
          queryArr.push(`${key}=${decodeURIComponent(routerQuery[key])}`);
        }
        path += `?${queryArr.join('&')}`;
      }

      // 这里没有对 hash 进行编码，因为外部传入的 hash 可能已经进行了编码
      if (isValidHash(hash)) {
        path += hash;
      }
    }
  } else if (typeof target === 'object' && target.path) {
    path = target.path;
  } else {
    path = '';
  }
  return path;
};

const getPageConfigByPath = (allPageConfig, fullPath) => {
  const pathList = parsePagePath(fullPath);
  let curPage = allPageConfig.find((item) => {
    if (item.fullPath === '/' && fullPath === item.fullPath) {
      return true;
    } else if (item !== '/') {
      return pathList[0] === item.fullPath;
    }
    return false;
  });

  if (!curPage) {
    return;
  }

  for (let index = 1; index <= pathList.length + 1; index += 1) {
    if (curPage.fullPath === fullPath) {
      return curPage;
    }
    const curPath = pathList.slice(0, index).join('');
    if (curPage.subPage && curPage.subPage[curPath]) {
      curPage = curPage.subPage[curPath];
    }
  }
};

const getTargetPath = (target, pageIdMap) => {
  let path = '';
  if (typeof target === 'string' && pageIdMap[target] && pageIdMap[target].fullPath) {
    path = pageIdMap[target].fullPath;
  } else if (typeof target === 'object' && target.path) {
    path = target.path;
  } else {
    path = target;
  }
  return path;
};

const getPageExtraConfig = (pageConfig) => ({
  __page_title: pageConfig.name,
  ...((pageConfig && pageConfig.extra) || {}),
});

const getLayoutMode = (pageConfig) => {
  if (pageConfig && pageConfig.layout && pageConfig.layout.mode) {
    return pageConfig.layout.mode;
  }
  return 'default';
};

const isRouterConfigSame = (config1, config2) => {
  if (config1 === config2) {
    return true;
  }
  //  config1.routerQuery 和 config2.routerQuery，判断是否相等
  let queryEqual = true;

  if (config1?.routerQuery && config2?.routerQuery) {
    const keys1 = Object.keys(config1?.routerQuery);
    const keys2 = Object.keys(config2?.routerQuery);
    if (keys1.length !== keys2.length) {
      queryEqual = false;
    }
    for (let i = 0; i < keys1.length; i += 1) {
      if (config1?.routerQuery[keys1[i]] !== config2?.routerQuery[keys1[i]]) {
        queryEqual = false;
        break;
      }
    }
  } else if (config1?.routerQuery === config2?.routerQuery) {
    queryEqual = true;
  }

  return config1?.fullPath === config2?.fullPath && queryEqual;
};

export {
  getLayoutMode,
  getTargetPath,
  parsePagePath,
  resolvePath,
  getPageConfigByPath,
  getPageExtraConfig,
  isRouterConfigSame,
};
